import { useReturnRequestsFilters } from "@/pages/(app)/returns/providers/use-return-requests-filters";
import { Input } from "@babackapp/ui/components/input";
import { Search } from "lucide-react";
import { ChangeEvent } from "react";
import { useDebouncedCallback } from "use-debounce";

export default function SearchInput() {
  const { updateSearch } = useReturnRequestsFilters();

  const onChange = useDebouncedCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      updateSearch({
        search: event?.target?.value ?? undefined,
      });
    },
    400,
  );

  return (
    <div className="relative h-10 w-80">
      <div className="absolute left-0 pl-2 bottom-0 top-0 pointer-events-none h-full flex items-center">
        <Search className="size-4 text-muted-foreground" />
      </div>
      <Input
        placeholder="Search by Order Name, Order Id..."
        className="pl-8 h-full"
        onChange={onChange}
      />
    </div>
  );
}
